import React from 'react';
import PropTypes from 'prop-types';

import Button from '../button';

import './chip.scss';

const Chip = props => {
  const { text, actionIcon, onAction } = props;

  const icon = <Button iconOnly={actionIcon} onClick={onAction} iconSize={8} kind="text" />;
  return (
    <div className="chip">
      <div className="chip-text">{text}</div>
      {icon}
    </div>
  );
};

Chip.propTypes = {
  text: PropTypes.string.isRequired,
  actionIcon: PropTypes.string,
  onAction: PropTypes.func,
};

Chip.defaultProps = {
  actionIcon: null,
  onAction: () => {},
};

export default Chip;
